import { render, staticRenderFns } from "./TabContractComments.vue?vue&type=template&id=b91bef58&scoped=true"
import script from "./TabContractComments.vue?vue&type=script&lang=js"
export * from "./TabContractComments.vue?vue&type=script&lang=js"
import style0 from "./TabContractComments.vue?vue&type=style&index=0&id=b91bef58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91bef58",
  null
  
)

export default component.exports